import { BuyerTenderDetailModel } from './../../buyer/models/buyer-tender.model';
import { BuyerTenderService } from 'src/app/pages/buyer/services/buyer-tender.service';
import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NzModalService } from "ng-zorro-antd/modal";
import { RatingsEnum } from "../../../services/crud-table/models/ratings.model";
import { RatingService } from "../../../services/rating.service";
import { BuyerOrderProductModel } from "../../buyer/models/buyer-order.model";
import { BuyerOrderService } from "../../buyer/services/buyer-order.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
	selector: "app-rate-supplier-modal",
	templateUrl: "./rate-supplier-modal.component.html",
	styleUrls: ["./rate-supplier-modal.component.scss"],
})
export class RateSupplierModalComponent implements OnInit, OnDestroy {
	@Input() data;
	@Input() ratingType;
	rateSupplierForm: FormGroup;
	ratingStatuses = RatingsEnum;

	constructor(
		private formBuilder: FormBuilder,
		private modalService: NzModalService,
		private ratingService: RatingService<any>,
		private spinnerService: NgxSpinnerService,
		private buyerOrderService: BuyerOrderService<BuyerOrderProductModel>,
		private buyerTenderService: BuyerTenderService<BuyerTenderDetailModel>,

	) {
		this.rateSupplierForm = this.formBuilder.group({
			overallRating: [null, [Validators.required, Validators.min(0.5), Validators.max(5)]],
			deliveryRating: [null, [Validators.required, Validators.min(0.5), Validators.max(5)]],
			communicationRating: [null, [Validators.required, Validators.min(0.5), Validators.max(5)]],
			description: ["", [Validators.required]],
		});
	}

	ngOnInit(): void {
	}

	submitRating() {
		this.spinnerService.show();
		const formData = this.rateSupplierForm.value;
		const payload = {
			supplierOrganizationId: this.data.supplierOrganizationId,
			buyerOrganizationId: this.data.buyerOrganizationId,
			buyerId: this.data.buyerId,
			referenceId: this.data._id,
			ratingType: this.ratingType === "tender" ? 1 : 2,
			overallRating: formData.overallRating,
			deliveryRating: formData.deliveryRating,
			communicationRating: formData.communicationRating,
			ratingText: formData.description,
		};

		this.ratingService.rateSupplier(payload).subscribe(
			(response) => {
				this.spinnerService.hide();
				this.modalService.closeAll();
				if(this.ratingType === "tender") {
					this.buyerTenderService.getTender(this.data._id);
				} else if(this.ratingType === "order") {
					this.buyerOrderService.getOrder(this.data._id);
				}

			},
			(error) => {
				console.error(error);
				this.modalService.closeAll();
			}
		);
	}

	ngOnDestroy(): void {
		this.rateSupplierForm.reset();
		this.modalService.closeAll();
	}

	/**
	 * get className according to rate value
	 */
	getRateClass(value) {
		return this.ratingService.getRateClass(value);
	}
}
